export type FaireItemCategory = 'flight' | 'hotel' | 'dining' | 'activity' | 'transport' | 'treat' | 'coffee' | 'drink' | 'other';

export interface FaireItem {
  id: string;
  name: string;
  date?: string;       // 'YYYY-MM-DD'
  time?: string;       // 'HH:MM' 24hr
  category?: FaireItemCategory;
  link?: string;
  notes?: string;
  location?: string;
  cost?: number;
}

export const FAIRE_CATEGORIES: {
  value: FaireItemCategory;
  label: string;
  emoji: string;
  bgColor: string;
  textColor: string;
}[] = [
  { value: 'flight',    label: 'Flight',    emoji: '🪶', bgColor: '#dff0e0', textColor: '#2d6a27' },
  { value: 'hotel',     label: 'Hotel',     emoji: '🏰', bgColor: '#ede3cc', textColor: '#7a4f1e' },
  { value: 'dining',    label: 'Dining',    emoji: '🍗', bgColor: '#f7e6c4', textColor: '#8b4513' },
  { value: 'activity',  label: 'Activity',  emoji: '⚔️',  bgColor: '#e8e0f0', textColor: '#5b3a82' },
  { value: 'transport', label: 'Transport', emoji: '🐎', bgColor: '#f0e8d5', textColor: '#7a5c2e' },
  { value: 'treat',     label: 'Treat',     emoji: '🍯', bgColor: '#fef3c7', textColor: '#b45309' },
  { value: 'coffee',    label: 'Coffee',    emoji: '🫖', bgColor: '#f5ead5', textColor: '#7c4f1d' },
  { value: 'drink',     label: 'Drink',     emoji: '🍺', bgColor: '#d4edd4', textColor: '#2d6a27' },
  { value: 'other',     label: 'Other',     emoji: '📜', bgColor: '#f0ead5', textColor: '#6b5230' },
];
